import { CSSProperties } from "react";
import { useLocation } from "react-router-dom";
import { Theme } from "@/lib/theme";

type Props = {
  theme: Theme;
  onToggleTheme: () => void;
  onOpenCmd: () => void;
};

const CRUMBS: Record<string, string[]> = {
  "/dashboard": ["Dashboard"],
  "/login": ["Anmeldung"],
  "/bookings": ["Buchungen"],
  "/calendar": ["Kalender"],
};

function getCrumbs(pathname: string): string[] {
  if (CRUMBS[pathname]) return CRUMBS[pathname];
  if (/^\/bookings\/\d+/.test(pathname)) return ["Buchungen", "Detail"];
  return ["Dashboard"];
}

const iconBtn = (): CSSProperties => ({
  width: 32,
  height: 32,
  border: "1px solid transparent",
  background: "transparent",
  borderRadius: 8,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "var(--fg-muted)",
  cursor: "pointer",
  transition: "background .12s ease, color .12s ease",
});

export function TopBar({ theme, onToggleTheme, onOpenCmd }: Props) {
  const location = useLocation();
  const crumbs = getCrumbs(location.pathname);

  return (
    <header
      style={{
        height: "var(--topbar-h)",
        display: "flex",
        alignItems: "center",
        gap: 16,
        padding: "0 24px",
        borderBottom: "1px solid var(--border)",
        background: "var(--bg-sidebar)",
        position: "sticky",
        top: 0,
        zIndex: 20,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 6, flex: 1, minWidth: 0 }}>
        {crumbs.map((c, i) => (
          <span key={`${c}-${i}`} style={{ display: "flex", alignItems: "center", gap: 6 }}>
            {i > 0 && <span style={{ color: "var(--fg-subtle)", fontSize: 13 }}>/</span>}
            <span
              style={{
                fontSize: 13,
                color: i === crumbs.length - 1 ? "var(--fg)" : "var(--fg-muted)",
                fontWeight: i === crumbs.length - 1 ? 600 : 400,
              }}
            >
              {c}
            </span>
          </span>
        ))}
      </div>

      <button
        onClick={onOpenCmd}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          padding: "6px 10px",
          background: "var(--bg-subtle)",
          border: "1px solid var(--border)",
          borderRadius: 8,
          cursor: "pointer",
          color: "var(--fg-muted)",
          fontSize: 13,
          minWidth: 260,
          fontFamily: "var(--font-body)",
        }}
      >
        <span className="material-icons-outlined" style={{ fontSize: 16 }}>
          search
        </span>
        <span style={{ flex: 1, textAlign: "left" }}>Seite, Buchung, Anfrage suchen…</span>
      </button>

      <button onClick={onToggleTheme} title={theme === "dark" ? "Hell" : "Dunkel"} style={iconBtn()}>
        <span className="material-icons-outlined" style={{ fontSize: 18 }}>
          {theme === "dark" ? "light_mode" : "dark_mode"}
        </span>
      </button>
    </header>
  );
}
